module.exports = __webpack_public_path__ + "img/sv84on.52daae16.svg";